import { filter, get } from "lodash";
import { useEffect, useState } from "react";
import { useQuery } from "shared/hooks/useApi";
import { SUBSCRIPTION } from "utils/api/graphql/queries/subscription";
import { AUTHORITY_TYPE, GENDER, KEYS, RELATIONSHIP } from "utils/constants";
import Navbar from "../Components/Navbar/Navbar";
import View from "./View";

const RelatedPersons = ({
  project,
  onNext,
  onBack,
  currentStatus,
  tracer,
  updateUrl,
}) => {
  const [initialValues, setInitialValues] = useState({
    children: [],
    spouse: undefined,
  });

  const subscriptionId =
    localStorage.getItem(KEYS.SUBSCRIPTION_ID) ||
    get(project, "fields.currentSubscription");

  const { data } = useQuery(SUBSCRIPTION, {
    variables: { where: { id: subscriptionId } },
  });

  const getAge = (birthdate) => {
    if (!birthdate) return 0;
    const today = new Date();
    const birth = new Date(birthdate);
    let age = today.getFullYear() - birth.getFullYear();
    const m = today.getMonth() - birth.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) {
      age--;
    }
    return age;
  };

  const normalizePerson = (person, isSpouse = false) => {
    if (!person?.identity) return person;
    const user = person.identity?.user ?? {};
    const age = getAge(user.birthDate);

    const backendAuthority = person.authority;

    const authority = isSpouse
      ? AUTHORITY_TYPE.SELF
      : age <= 18
        ? backendAuthority === undefined ||
          backendAuthority === AUTHORITY_TYPE.SELF
          ? AUTHORITY_TYPE.FATHER
          : backendAuthority
        : (backendAuthority ?? null);

    return {
      ...person,
      authority,
      identity: {
        ...person.identity,
        socialSecurityNumber: person.identity?.socialSecurityNumber ?? "",
        user: {
          id: user.id ?? "",
          firstname: user.firstname ?? "",
          lastname: user.lastname ?? "",
          gender: user.gender ?? GENDER.MALE,
          birthDate: user.birthDate ?? "",
        },
      },
    };
  };

  useEffect(() => {
    const contact =
      get(project, "contact") || get(data, "subscription.project.contact");
    const relatedPersons = get(contact, "relatedPersons", []);

    const children = filter(relatedPersons, {
      relationship: RELATIONSHIP.CHILD,
    }).map((p) => {
      const person = normalizePerson(p);
      return person;
    });

    const spouseRaw = relatedPersons.find(
      (p) => p.relationship === RELATIONSHIP.SPOUSE,
    );
    const spouse = spouseRaw ? normalizePerson(spouseRaw, true) : undefined;

    setInitialValues({ children, spouse });
  }, [project, data]);

  const onSubmit = ({ spouse, children }) => {
    const source = localStorage.getItem(KEYS.SOURCE);

    const normalizedChildren = children.map((p) => normalizePerson(p));
    const normalizedSpouse = spouse ? normalizePerson(spouse, true) : undefined;

    const relatedPersons = [
      ...(normalizedSpouse ? [normalizedSpouse] : []),
      ...normalizedChildren,
    ];

    setInitialValues({
      children: normalizedChildren,
      spouse: normalizedSpouse,
    });

    updateUrl({
      subscriptionId,
      url: get(
        data,
        "subscription.insurancePlan.config.generatedUrl",
        `${process.env.REACT_APP_BASE_URL}/#/public/process/init/${source}`,
      ),
    });

    const contact =
      get(project, "contact") || get(data, "subscription.project.contact");

    onNext({
      payload: {
        contact: {
          ...contact,
          relatedPersons,
        },
      },
    });
  };

  return (
    <>
      <Navbar
        project={project}
        progress={currentStatus?.progress}
        tracer={tracer}
        showCart
        step={4}
        stepCount={5}
        title="Mes informations contractuelles"
      />
      <View
        key={JSON.stringify(initialValues)}
        children={initialValues.children}
        spouse={initialValues.spouse}
        onNext={onSubmit}
        onBack={onBack}
      />
    </>
  );
};

export default RelatedPersons;
